<div class="card-busca-unidade">
  <form [formGroup]="formUnidade" (ngSubmit)="buscarUnidade()" *ngIf="servico?.comMatricula && !dadosUnidade"
    class="flex gap-2 flex-column">
    <label>Tipo Usuário Unidade:</label>

    <p-dropdown #tipoUsuarioUnidade formControlName="tipoUsuarioUnidade" [options]="TIPO_USUARIO_UNIDADE"
      (onChange)="limparCpfCnpj()"></p-dropdown>

    <label>CPF ou CNPJ:</label>
    <div class="documento-wrapper">
      <p-inputMask #cpfCnpjUnidade id="cpfCnpjUnidade" mask="999.999.999-99" [unmask]="true"
        *ngIf="tipoUsuarioUnidade.value == TIPO_USUARIO_UNIDADE[0]" formControlName="cpfCnpjUnidade" />
      <p-inputMask #cpfCnpjUnidade id="cpfCnpjUnidade" [unmask]="true" mask="99.999.999/9999-99"
        *ngIf="tipoUsuarioUnidade.value == TIPO_USUARIO_UNIDADE[1]" formControlName="cpfCnpjUnidade" />
      <small id="cpfCnpjUnidade-help">
        Documento do usuário da unidade na CASAN.
      </small>
      <small class="p-error block" *ngIf="
          formUnidade.get('cpfCnpjUnidade')?.invalid &&
          (formUnidade.get('cpfCnpjUnidade')?.dirty ||
            formUnidade.get('cpfCnpjUnidade')?.touched)
        ">
        <ng-container *ngIf="formUnidade.get('cpfCnpjUnidade')?.errors?.['required']">
          Campo Obrigatório.
        </ng-container>
        <ng-container *ngIf="formUnidade.get('cpfCnpjUnidade')?.errors?.['pattern']">
          <ng-container *ngIf="formUnidade.get('cpfCnpjUnidade')?.getRawValue().length < 11">
            CPF Inválido.
          </ng-container>
          <ng-container *ngIf="formUnidade.get('cpfCnpjUnidade')?.getRawValue().length > 11">
            CNPJ Inválido.
          </ng-container>
        </ng-container>
      </small>
    </div>

    <label for="matricula">Matrícula:</label>
    <div class="documento-wrapper">
      <p-inputNumber inputId="matricula" mode="decimal" [useGrouping]="false"
        formControlName="matricula"></p-inputNumber>
      <small id="matricula-help"> Matrícula da unidade na CASAN. </small>

      <small class="p-error block" *ngIf="
          formUnidade.get('matricula')?.invalid &&
          (formUnidade.get('matricula')?.dirty ||
            formUnidade.get('matricula')?.touched)
        ">
        <div *ngIf="formUnidade.get('matricula')?.errors?.['required']">
          Campo Obrigatório.
        </div>
      </small>
    </div>
    <button pButton type="submit" [disabled]="formUnidade.invalid || formUnidade.disabled" label="Encontrar unidade"
      class="botao-proximo" [loading]="loading"></button>
  </form>

  <form [formGroup]="form" (ngSubmit)="enviarSolicitante()" *ngIf="!servico?.comMatricula || dadosUnidade">
    <div>
      <label>Nome do solicitante:</label>
      <input pInputText id="nomeSolicitante" formControlName="nomeSolicitante" autocomplete="off"
        aria-label="Nome do solicitante" />
      <label>CPF do solicitante:</label>
      <p-inputMask id="cpfSolicitante" mask="999.999.999-99" formControlName="cpfSolicitante" autocomplete="off"
        ariaLabel="CPF do solicitante" />

      <ng-container *ngIf="!form.get('naoPossuiEmail')?.value">
        <label>E-mail do solicitante:</label>
        <input pInputText id="emailSolicitante" style="max-width: 400px" formControlName="emailSolicitante"
          autocomplete="off" aria-label="E-mail do solicitante" />
      </ng-container>
      <p-checkbox *ngIf="origem == 'interno'" name="naoPossuiEmail" label="Não possuo e-mail"
        formControlName="naoPossuiEmail" [binary]="true" />

      <label>Celular do solicitante:</label>
      <p-inputMask id="telefoneSolicitante" mask="(99) 99999-9999" formControlName="telefoneSolicitante"
        autocomplete="off" ariaLabel="Celular do solicitante" />
      <label>Local de prestação do serviço:</label>
      <p-dropdown [options]="municipios" formControlName="municipio" optionLabel="nome" [filter]="true" filterBy="name"
        placeholder="Seleciona o município" ariaLabel="Municipio de prestação do serviço">
      </p-dropdown>
      <ng-container *ngIf="servico?.solicitarDetalhesEndereco">
        <label>Endereço da instalação da Ligação de Água:</label>
        <input pInputText id="endereco" style="max-width: 400px" formControlName="endereco" autocomplete="off"
          maxlength="512" aria-label="Endereço" />
        <label>Complemento ao Endereço de instalação da Ligação de Água:</label>
        <input pInputText id="complementoEndereco" style="max-width: 400px" formControlName="complementoEndereco"
          maxlength="256" autocomplete="off" aria-label="Complemento endereço" />
        <label>Bairro:</label>
        <input pInputText id="bairro" style="max-width: 400px" formControlName="bairro" autocomplete="off"
          maxlength="256" aria-label="Bairro" />
      </ng-container>
    </div>
    <!-- Declarações de tipo de usuário -->
    <div class="flex flex-column gap-0 mt-5" *ngIf="mostrarDeclaracoes">
      <div class="field-checkbox">
        <p-radioButton inputId="usuario" name="tipoUsuario" value="0" formControlName="tipoUsuario"
          ariaLabel="Declaro que sou o usuário da unidade ou possuo a documentação necessária para representa-lo"></p-radioButton>
        <label for="usuario" class="ml-2">
          Declaro que sou o usuário da unidade ou possuo a documentação
          necessária para representá-lo
        </label>
      </div>
      <div class="field-checkbox">
        <p-radioButton inputId="proprietario" name="tipoUsuario" value="1" formControlName="tipoUsuario"
          ariaLabel="Declaro que sou o proprietário do imóvel/terreno ou possuo documentação necessária para representa-lo"></p-radioButton>
        <label for="proprietario" class="ml-2">
          Declaro que sou o proprietário do imóvel/terreno ou possuo
          documentação necessária para representá-lo
        </label>
      </div>
    </div>
    <!-- Declarações de aceite e veracidade-->
    <ng-container *ngIf="mostrarDeclaracoes">
      <h4 class="subtitulo">Declaração de Veracidade</h4>
      <p style="font-size: 12px; margin-top: 10px">
        Declaro que as informações prestadas e documentos apresentados são
        verdadeiros e estou ciente de que, em caso de vistoria "in loco", havendo
        divergência nas informações declaradas, estarei sujeito as sanções e
        penalidades e ao pagamento da indenização da diferença dos valores entre
        as tarifas aplicadas, ao preço vigente na ocasião da vistoria.
      </p>

      <p-checkbox formControlName="declaracaoVeracidade" value="aceite" inputId="declaracaoVeracidade"
        label="Li e concordo"></p-checkbox>
      <h4 class="subtitulo">Declaração de Aceite</h4>
      <p style="font-size: 12px; margin-top: 10px">
        Estou ciente de que em caso de não envio da documentação compromissada,
        após a análise da CASAN, será gerada a REJEIÇÃO IMEDIATA do atendimento e
        será necessária a abertura de uma nova solicitação, com a documentação
        completa. Declaro, ainda, estar ciente de que na hipótese acima citada, o
        corte e/ou supressão de ligação ou cancelamento dos serviços não decorre
        do eventual inadimplemento financeiro das obrigações contratuais, mas sim
        da violação do princípio da confiança e da boa-fé objetiva, em razão do
        descumprimento do compromisso assumido de entrega de documentos, visando,
        assim, proporcionar segurança jurídica mínima às relações comerciais da
        Companhia. Lembramos que sempre que necessário, a CASAN se reserva o
        direito de solicitar outros documentos além dos já requeridos, de acordo
        com a peculiaridade de cada caso.
      </p>

      <p-checkbox formControlName="declaracaoAceite" value="aceite" inputId="declaracaoAceite"
        label="Li e concordo"></p-checkbox>
    </ng-container>
    <button pButton type="submit" [disabled]="form.invalid || form.disabled" label="Próximo" class="botao-proximo"
      [loading]="loading"></button>
  </form>
</div>